/* ============================================================
   DeckWächter — Glücksrad mit E-Mail-Capture (global)
   - Seiten-Tab links; öffnet Modal mit Glücksrad
   - E-Mail wird als Newsletter-Abo an Shopify gesendet (/contact)
   - Gewinn = echter Rabattcode (GLUECK5 / GLUECK7 / GLUECK10)
   - einmal pro Besucher (localStorage)
   ============================================================ */
(function () {
  if (window.__dwGl) return; window.__dwGl = true;
  var DONE_KEY = 'dwGluckDone';
  try { } catch (e) {}
  var PRIZES = [
    { l: '10%', c: 'GLUECK10' },
    { l: '5%',  c: 'GLUECK5'  },
    { l: '7%',  c: 'GLUECK7'  },
    { l: '5%',  c: 'GLUECK5'  },
    { l: '7%',  c: 'GLUECK7'  },
    { l: '5%',  c: 'GLUECK5'  }
  ];
  var SEG = 360 / PRIZES.length;

  var css = document.createElement('style');
  css.textContent =
    "@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Oswald:wght@600;700&display=swap');" +
    ".dwgl-tab{position:fixed;left:0;top:50%;transform:translateY(-50%);z-index:9997;background:linear-gradient(135deg,#ff3b2f,#ff6a00);color:#170505;font-family:'Oswald',sans-serif;font-weight:700;letter-spacing:.5px;writing-mode:vertical-rl;text-orientation:mixed;padding:14px 9px;border-radius:0 12px 12px 0;border:0;cursor:pointer;box-shadow:0 6px 22px rgba(255,59,47,.4);font-size:13px;text-transform:uppercase;}" +
    ".dwgl-tab span{transform:rotate(180deg);display:inline-block;}" +
    ".dwgl-ov{position:fixed;inset:0;z-index:9999;background:rgba(4,2,3,.78);backdrop-filter:blur(4px);display:none;align-items:center;justify-content:center;padding:18px;font-family:'Inter',sans-serif;}" +
    ".dwgl-ov.open{display:flex;}" +
    ".dwgl-modal{position:relative;width:100%;max-width:430px;background:linear-gradient(180deg,#190809,#0c0506);border:1px solid rgba(255,120,80,.3);border-radius:22px;padding:26px 24px 28px;text-align:center;color:#f6efe9;box-shadow:0 30px 80px rgba(0,0,0,.6);}" +
    ".dwgl-x{position:absolute;top:9px;right:9px;background:rgba(255,255,255,.07);border:1px solid rgba(255,120,80,.25);color:#d8c7bf;font-size:21px;cursor:pointer;line-height:1;width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:transparent;transition:.18s;}" +
    ".dwgl-x:active{transform:scale(.92);}" +
    ".dwgl-x:hover{color:#ff7a3c;}" +
    ".dwgl-kick{font-family:'Oswald',sans-serif;text-transform:uppercase;letter-spacing:1.4px;font-size:12px;color:#ff7a3c;}" +
    ".dwgl-h{font-family:'Oswald',sans-serif;text-transform:uppercase;font-size:25px;margin:5px 0 2px;letter-spacing:.4px;}" +
    ".dwgl-p{color:#c8b7af;font-size:13.5px;margin:0 0 16px;}" +
    ".dwgl-wheelwrap{position:relative;width:250px;height:250px;margin:0 auto 18px;}" +
    ".dwgl-point{position:absolute;top:-14px;left:50%;transform:translateX(-50%);width:0;height:0;border-left:17px solid transparent;border-right:17px solid transparent;border-top:32px solid #ffd27a;z-index:5;filter:drop-shadow(0 3px 4px rgba(0,0,0,.75));}" +
    ".dwgl-wheel{width:250px;height:250px;border-radius:50%;position:relative;border:6px solid #2a1311;box-shadow:0 0 0 4px rgba(255,120,80,.35),0 12px 40px rgba(0,0,0,.5);transition:transform 4.6s cubic-bezier(.12,.7,.18,1);}" +
    ".dwgl-lbl{position:absolute;left:50%;top:50%;transform-origin:center;font-family:'Oswald',sans-serif;font-weight:700;font-size:18px;color:#fff;text-shadow:0 1px 3px rgba(0,0,0,.75);white-space:nowrap;}" +
    ".dwgl-hub{position:absolute;top:50%;left:50%;width:46px;height:46px;transform:translate(-50%,-50%);border-radius:50%;background:linear-gradient(135deg,#ff3b2f,#ff6a00);border:3px solid #2a1311;z-index:6;box-shadow:0 0 0 3px rgba(255,150,80,.22),0 5px 14px rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;}.dwgl-arrow{position:relative;display:block;width:18px;height:23px;}.dwgl-arrow::after{content:'';position:absolute;left:50%;top:0;transform:translateX(-50%);width:0;height:0;border-left:9px solid transparent;border-right:9px solid transparent;border-bottom:13px solid #fff;filter:drop-shadow(0 1px 1px rgba(0,0,0,.45));}.dwgl-arrow::before{content:'';position:absolute;left:50%;top:11px;transform:translateX(-50%);width:6px;height:11px;background:#fff;border-radius:0 0 2px 2px;}" +
    ".dwgl-field{display:flex;gap:8px;margin-bottom:10px;}" +
    ".dwgl-field input{flex:1;background:rgba(255,255,255,.06);border:1px solid rgba(255,120,80,.3);border-radius:11px;color:#fff;font-size:15px;padding:13px 14px;outline:none;}" +
    ".dwgl-field input:focus{border-color:#ff6a00;box-shadow:0 0 0 3px rgba(255,90,42,.16);}" +
    ".dwgl-spin{width:100%;background:linear-gradient(135deg,#ff3b2f,#ff6a00);color:#170505;border:0;border-radius:12px;font-family:'Oswald',sans-serif;font-weight:700;text-transform:uppercase;letter-spacing:.6px;font-size:16px;padding:15px;cursor:pointer;box-shadow:0 8px 24px rgba(255,59,47,.3);}" +
    ".dwgl-spin:disabled{opacity:.55;cursor:not-allowed;}" +
    ".dwgl-note{color:#7c6a63;font-size:11px;margin-top:10px;}" +
    ".dwgl-err{color:#ff8a6a;font-size:12.5px;margin:0 0 8px;min-height:14px;}" +
    ".dwgl-win{margin-top:6px;}" +
    ".dwgl-win .code{display:inline-block;font-family:'Oswald',sans-serif;font-weight:700;font-size:22px;letter-spacing:2px;color:#170505;background:linear-gradient(135deg,#ffd27a,#ff8a3c);padding:10px 20px;border-radius:12px;margin:8px 0;}" +
    ".dwgl-win .redeem{display:block;margin-top:10px;background:linear-gradient(135deg,#ff3b2f,#ff6a00);color:#170505;font-family:'Oswald',sans-serif;font-weight:700;text-transform:uppercase;letter-spacing:.5px;padding:13px;border-radius:12px;text-decoration:none;}" +
    "@media(max-width:480px){.dwgl-tab{font-size:12px;padding:12px 7px;}.dwgl-x{width:44px;height:44px;font-size:23px;}.dwgl-modal{padding:24px 18px 24px;}}";
  (document.head || document.documentElement).appendChild(css);

  var tab = document.createElement('button');
  tab.className = 'dwgl-tab';
  tab.innerHTML = '<span>🎁 Gratis drehen</span>';

  var ov = document.createElement('div');
  ov.className = 'dwgl-ov';
  var labels = '';
  PRIZES.forEach(function (p, i) {
    var a = i * SEG; // Grad vom oberen Punkt (Segment-Mitte)
    var rad = a * Math.PI / 180;
    var r = 80;
    var x = Math.sin(rad) * r, y = -Math.cos(rad) * r;
    var rot = (a > 90 && a < 270) ? a + 180 : a; // untere Hälfte spiegeln -> immer lesbar
    labels += '<span class="dwgl-lbl" style="transform:translate(-50%,-50%) translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) rotate(' + rot + 'deg);">' + p.l + '</span>';
  });
  // konische Segmente (abwechselnd), Start oben (-90deg + halbes Segment Offset)
  var stops = [];
  for (var i = 0; i < PRIZES.length; i++) {
    var col = (i % 2 === 0) ? '#3a1410' : '#5a1c0e';
    stops.push(col + ' ' + (i * SEG) + 'deg ' + ((i + 1) * SEG) + 'deg');
  }
  var wheelBg = 'conic-gradient(from ' + (-SEG / 2) + 'deg,' + stops.join(',') + ')';
  ov.innerHTML =
    '<div class="dwgl-modal">' +
      '<button class="dwgl-x" aria-label="Schließen">×</button>' +
      '<div class="dwgl-kick">🎁 DeckWächter Glücksrad</div>' +
      '<div class="dwgl-h">Dreh & gewinne</div>' +
      '<p class="dwgl-p">Gib deine E-Mail ein, dreh am Rad und sichere dir deinen Rabatt-Code. Nur für Newsletter-Abonnenten.</p>' +
      '<div class="dwgl-wheelwrap">' +
        '<div class="dwgl-point"></div>' +
        '<div class="dwgl-wheel" style="background:' + wheelBg + '">' + labels + '</div><div class="dwgl-hub"><span class="dwgl-arrow"></span></div>' +
      '</div>' +
      '<div class="dwgl-stage">' +
        '<p class="dwgl-err"></p>' +
        '<div class="dwgl-field"><input type="email" placeholder="deine@email.de" autocomplete="email"></div>' +
        '<button class="dwgl-spin">Drehen &amp; gewinnen</button>' +
        '<p class="dwgl-note">Mit dem Drehen meldest du dich zum Newsletter an. Abmeldung jederzeit. Ein Gewinn pro Person.</p>' +
      '</div>' +
    '</div>';

  function mount() {
    if (!document.body) return setTimeout(mount, 50);
    document.body.appendChild(tab);
    document.body.appendChild(ov);
    var wheel = ov.querySelector('.dwgl-wheel');
    var input = ov.querySelector('.dwgl-field input');
    var spinBtn = ov.querySelector('.dwgl-spin');
    var errEl = ov.querySelector('.dwgl-err');
    var stage = ov.querySelector('.dwgl-stage');
    var spinning = false, rot = 0;

    function open() { ov.classList.add('open'); }
    function close() { ov.classList.remove('open'); }
    tab.addEventListener('click', open);
    ov.querySelector('.dwgl-x').addEventListener('click', close);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });

    var done = false;
    try { done = !!localStorage.getItem(DONE_KEY); } catch (e) {}
    if (done) { tab.style.display = 'none'; }
    else { setTimeout(function () { if (!ov.classList.contains('open')) open(); }, 11000); }

    function validEmail(v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v); }

    function subscribe(email) {
      try {
        var fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('contact[email]', email);
        fd.append('contact[tags]', 'newsletter,gluecksrad');
        fetch('/contact', { method: 'POST', body: fd }).catch(function () {});
      } catch (e) {}
    }

    function pickPrize() {
      var r = Math.random();
      var want = r < 0.1 ? '10%' : (r < 0.45 ? '7%' : '5%');
      var idxs = []; PRIZES.forEach(function (p, i) { if (p.l === want) idxs.push(i); });
      return idxs[Math.floor(Math.random() * idxs.length)];
    }

    function showWin(prize) {
      stage.innerHTML =
        '<div class="dwgl-win"><div style="font-size:15px;">🎉 Glückwunsch! Du hast <b style="color:#ff9a4c;">' + prize.l + ' Rabatt</b> gewonnen.</div>' +
        '<span class="code">' + prize.c + '</span>' +
        '<div style="font-size:12px;color:#c8b7af;">Code gilt für deine nächste Bestellung (einmalig).</div>' +
        '<a class="redeem" href="/discount/' + prize.c + '?redirect=/collections/frontpage">Code einlösen &amp; shoppen</a></div>';
    }

    spinBtn.addEventListener('click', function () {
      if (spinning) return;
      var email = (input.value || '').trim();
      if (!validEmail(email)) { errEl.textContent = 'Bitte gib eine gültige E-Mail-Adresse ein.'; return; }
      errEl.textContent = '';
      spinning = true; spinBtn.disabled = true; spinBtn.textContent = 'Dreht …';
      subscribe(email);
      var idx = pickPrize();
      var prize = PRIZES[idx];
      var jitter = (Math.random() - 0.5) * (SEG - 14);
      var target = 360 * 5 - (idx * SEG) - jitter; // unter den Zeiger oben bringen
      rot += target;
      wheel.style.transform = 'rotate(' + rot + 'deg)';
      try { localStorage.setItem(DONE_KEY, '1'); } catch (e) {}
      tab.style.display = 'none';
      setTimeout(function () { showWin(prize); }, 4800);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();
